/**
 * Build a CSV string from rows of objects and trigger a browser download.
 *
 *   exportRowsToCsv({
 *     filename: "productos-2026-02-09.csv",
 *     headers: [
 *       { key: "nombre",     label: "Nombre" },
 *       { key: "categoria",  label: "Categoría" },
 *       { key: "costo",      label: "Costo" },
 *     ],
 *     rows: items, // any[] — each row is read via header.key
 *   });
 *
 * Escapes commas, quotes and newlines per RFC 4180.  Adds a UTF-8 BOM so
 * Excel opens accented characters correctly.
 */
export function exportRowsToCsv({ filename, headers, rows }) {
  const escape = (v) => {
    const s = v === null || v === undefined ? "" : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const headerLine = headers.map((h) => escape(h.label)).join(",");
  const dataLines = rows.map((row) =>
    headers
      .map((h) => {
        const raw = typeof h.value === "function" ? h.value(row) : row[h.key];
        return escape(raw);
      })
      .join(","),
  );
  const csv = "\uFEFF" + [headerLine, ...dataLines].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Build a yyyy-mm-dd date stamp for filenames. */
export function todayStamp() {
  return new Date().toISOString().slice(0, 10);
}
